import React from 'react';
import { Button, type ButtonProps } from './button';

/** Preserve caller-owned gating and form props while explaining unavailable slot actions. */
export function withDisabledReason(
  node: React.ReactNode,
  reason = 'This action is currently unavailable.',
): React.ReactNode {
  return React.Children.map(node, (child) => {
    if (!React.isValidElement<ButtonProps>(child)) return child;
    const props = child.props;
    if ((child.type === Button || child.type === 'button') && (props.disabled || props.isLoading)) {
      const next = { ...props, disabledReason: props.disabledReason ?? reason };
      return child.type === 'button' ? <Button {...next} /> : React.cloneElement(child, next);
    }
    // Fragments and layout wrappers can group slot actions; custom controls own their internals.
    if (child.type === React.Fragment || typeof child.type === 'string') {
      return React.cloneElement(child, {}, withDisabledReason(props.children, reason));
    }
    return child;
  });
}
